import React, { useState } from 'react';
import { Button, Drawer, Grid, Modal } from 'antd';
import {
  InfoCircleFilledIcon,
  UniversityExperienceInfo,
  UniversityGraduatedInfo,
  UniversityStudentInfo,
  UniversityTeacherInfo
} from 'icons';
import Image from 'next/image';
import { useTranslations } from 'use-intl';

import { IAllUniversities, UniversityTypes } from '../models';

import { ContactSection } from './item/left-side';

const { useBreakpoint } = Grid;

interface IProps {
  university?: IAllUniversities;
}

const InfoTrigger: React.FC<IProps> = ({ university }) => {
  const t = useTranslations();
  const screens = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const isTablet = screens.sm && !screens.md;

  const content = (
    <>
      <div className="mt-5">
        {university?.image ? (
          <div className="relative max-h-40 min-h-55 w-full">
            <Image
              fill
              className="rounded-xl object-cover"
              src={university.image.trimEnd() || '/images/default-no-image.webp'}
              alt={university.name}
              title='Universitet rasmi'
            />
          </div>
        ) : (
          <div className="relative flex max-h-40 min-h-40 w-full items-center justify-center rounded-t-xl bg-gray-50">
            <Image
              width={70}
              height={70}
              className="object-cover"
              src="/images/default-no-image.webp"
              alt={university?.name || 'Universitet'}
              title='Universitet rasmi'
            />
          </div>
        )}
      </div>

      {university?.type === UniversityTypes.PRIVATE && (
        <div className="mt-3 grid grid-cols-4 gap-2">
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityStudentInfo />
            <p className="text-xs text-gray-400">{t('Talaba')}</p>
            <p className="text-sm font-medium text-gray-800">{university.students_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityGraduatedInfo />
            <p className="text-xs text-gray-400">{t('Bitiruvchi')}</p>
            <p className="text-sm font-medium text-gray-800">{university.graduate_students_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityTeacherInfo />
            <p className="text-xs text-gray-400">{t('Oqituvchi')}</p>
            <p className="text-sm font-medium text-gray-800">{university.courses_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityExperienceInfo />
            <p className="text-xs text-gray-400">{t('Tajriba')}</p>
            <p className="text-sm font-medium text-gray-800">{university.experience_years_count || '-'}</p>
          </div>
        </div>
      )}

      <div className='mt-5'>
        <ContactSection university={university} />
      </div>
    </>
  );

  return (
    <>
      <div
        className="absolute bottom-10 right-5 z-11 flex h-12 w-12 cursor-pointer items-center justify-center rounded-lg bg-green-500 md:flex text-white"
        onClick={handleClick}
      >
        <div>
          <InfoCircleFilledIcon />
        </div>
      </div>

      {isTablet ? (
        <Modal
          closeIcon={false}
          open={isOpen}
          onCancel={handleClose}
          footer={
            <Button onClick={handleClose} className="!my-2 !w-full !rounded-lg !border-transparent !bg-gray-100 !py-4">
              {t('tushunarlik')}
            </Button>
          }
          title={t('malumot')}
          styles={{
            content: { padding: '8px 10px 3px 10px', borderRadius: '12px' }
          }}
        >
          {content}
        </Modal>
      ) : (
        <Drawer
          closeIcon={false}
          open={isOpen}
          onClose={handleClose}
          className="rounded-t-xl"
          placement="bottom"
          title={t('malumot')}
          height={university?.type === UniversityTypes.PRIVATE ? '85%' : '70%'}
          footer={
            <Button onClick={handleClose} className="!my-2 !w-full !rounded-lg !border-transparent !bg-gray-100 !py-4">
              {t('tushunarlik')}
            </Button>
          }
          styles={{
            body: { padding: '8px 10px 3px 10px' }
          }}
        >
          {content}
        </Drawer>
      )}
    </>
  );
};

export default InfoTrigger;
